// hooks/useStateWithStorage.ts
"use client";
import { useState, useEffect } from "react";
import { storage } from "libs";
import { StorageOpts } from "types";

const useStateWithStorage = (
  defaultValue: string | undefined,
  storageName: string,
  opts: StorageOpts
) => {
  const [value, setValue] = useState<any>(defaultValue);

  useEffect(() => {
    setValue(storage.get(storageName, defaultValue, opts));
  }, []);

  const setValueWithStorage = (val: string | undefined) => {
    if (val !== value) {
      if (val !== undefined) {
        storage.set(storageName, val, opts);
      } else {
        storage.remove(storageName);
      }
    }

    setValue(val);
  };

  return [value, setValueWithStorage];
};

export default useStateWithStorage;
